import React, { useEffect, useState, useMemo } from 'react'
import { Message } from '@cx/ui'
import { TextField, Stack } from '@mui/material'
import { postApplyInvoice } from '@/api'
import { Controller, useForm } from 'react-hook-form'
import Modal2 from '@/components/Modal2'
import ConfirmInvoiceModal from './ConfirmInvoiceModal'

interface DownloadContractModalProps {
  open: boolean
  data: any
  onCancel: () => void
  onOk: () => void
}

const DownloadContractModal: React.FC<DownloadContractModalProps> = ({ open, onCancel, onOk, data: propsData }) => {
  const [visible, setVisible] = useState(false)
  const [formValues, setFormValues] = useState<any>({})

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm({
    defaultValues: {
      owner: '',
      legal_person: '',
      unified_social_credit_code: '',
      contact_address: '',
      authorized_representative: '',
      telephone: '',
      email: '',
      owner_contract_no: '',
    },
  })

  const onSubmit = handleSubmit((data) => {
    window.open(
      `/api/v1/order/contract?order_code=${propsData.order_code}&owner=${data.owner}&legal_person=${data.legal_person}&unified_social_credit_code=${data.unified_social_credit_code}&contact_address=${data.contact_address}&authorized_representative=${data.authorized_representative}&telephone=${data.telephone}&email=${data.email}&owner_contract_no=${data.owner_contract_no}`,
    )
    onCancel()
  })

  useEffect(() => {
    if (!open) {
      reset()
    }
  }, [open])

  return (
    <Modal2 title='下载合同' width={806} open={open} onCancel={onCancel} onOk={onSubmit}>
      <Stack direction='row' flexWrap='wrap' gap={3}>
        <Controller
          rules={{ required: '请输入甲方' }}
          name='owner'
          control={control}
          render={({ field }) => (
            <TextField
              required
              {...field}
              variant='outlined'
              placeholder='请输入甲方'
              sx={{ width: 'calc(50% - 12px)' }}
              label='甲方'
              error={Boolean(errors.owner)}
              helperText={errors.owner?.message as string}
              size='small'
              autoComplete='off'
            />
          )}
        />
        <Controller
          rules={{ required: '请输入法人' }}
          name='legal_person'
          control={control}
          render={({ field }) => (
            <TextField
              required
              {...field}
              variant='outlined'
              placeholder='请输入法人'
              label='法人'
              sx={{ width: 'calc(50% - 12px)' }}
              error={Boolean(errors.legal_person)}
              helperText={errors.legal_person?.message as string}
              size='small'
              autoComplete='off'
            />
          )}
        />
        <Controller
          rules={{ required: '请输入统一社会信用代码' }}
          name='unified_social_credit_code'
          control={control}
          render={({ field }) => (
            <TextField
              required
              {...field}
              variant='outlined'
              placeholder='请输入统一社会信用代码'
              label='统一社会信用代码'
              sx={{ width: 'calc(50% - 12px)' }}
              error={Boolean(errors.unified_social_credit_code)}
              helperText={errors.unified_social_credit_code?.message as string}
              size='small'
              autoComplete='off'
            />
          )}
        />

        <Controller
          rules={{ required: '请输入授权代表' }}
          name='authorized_representative'
          control={control}
          render={({ field }) => (
            <TextField
              required
              {...field}
              variant='outlined'
              placeholder='请输入授权代表'
              label='授权代表'
              sx={{ width: 'calc(50% - 12px)' }}
              error={Boolean(errors.authorized_representative)}
              helperText={errors.authorized_representative?.message as string}
              size='small'
              autoComplete='off'
            />
          )}
        />
        <Controller
          rules={{ required: '请输入联系电话' }}
          name='telephone'
          control={control}
          render={({ field }) => (
            <TextField
              required
              {...field}
              variant='outlined'
              placeholder='请输入联系电话'
              label='联系电话'
              sx={{ width: 'calc(50% - 12px)' }}
              error={Boolean(errors.telephone)}
              helperText={errors.telephone?.message as string}
              size='small'
              autoComplete='off'
            />
          )}
        />
        <Controller
          rules={{ required: '请输入邮箱' }}
          name='email'
          control={control}
          render={({ field }) => (
            <TextField
              required
              {...field}
              variant='outlined'
              placeholder='请输入邮箱'
              label='邮箱'
              sx={{ width: 'calc(50% - 12px)' }}
              error={Boolean(errors.email)}
              helperText={errors.email?.message as string}
              size='small'
              autoComplete='off'
            />
          )}
        />
        <Controller
          rules={{ required: '请输入联系地址' }}
          name='contact_address'
          control={control}
          render={({ field }) => (
            <TextField
              required
              {...field}
              variant='outlined'
              placeholder='请输入联系地址'
              label='联系地址'
              fullWidth
              error={Boolean(errors.contact_address)}
              helperText={errors.contact_address?.message as string}
              size='small'
              autoComplete='off'
            />
          )}
        />
        <Controller
          name='owner_contract_no'
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              variant='outlined'
              placeholder='请输入联系地址'
              label='甲方合同编号'
              fullWidth
              error={Boolean(errors.owner_contract_no)}
              helperText={errors.owner_contract_no?.message as string}
              size='small'
              autoComplete='off'
            />
          )}
        />
      </Stack>
    </Modal2>
  )
}

export default DownloadContractModal
